import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  flex: 1;

  max-width: 1024px;

  width: 100%;
`;

export const Main = styled.main`
  display: flex;
  justify-content: center;

  flex: 1;

  margin-top: 50px;
`;
